import { distinctValues } from '@artup/utilities'
import { Principal } from './principal'

/**
 * Predefined security profiles
 */
export const StandardSecurityProfiles = {
  Super: 'super',
  Integration: 'integration',
  Administrator: 'administrator',
  User: 'user'
}

/**
 * Security profile, a named set of permissions assigned to an avatar.
 * Not to be confused with the public profile of an artist or an organization.
 */
export class SecurityProfile extends Principal {
  constructor (data = {}) {
    super(data)
    this.assign({
      ...data
    })
  }

  /**
   * Normalizes the assigned data
   */
  normalize () {
    super.normalize()
  }

  /**
   * Long user-friendly label better describing the profile
   * @type {String}
   */
  details

  /**
   * Icon representing the profile
   * @type {String}
   */
  icon

  /**
   * Extends permissions of the profile with those of the other profile
   * @param {SecurityProfile} profile Security profile to borrow permissions from
   */
  extendFrom (profile) {
    if (profile) {
      this.allow = distinctValues([...this.allow, ...profile.allow])
      this.deny = distinctValues([...this.deny, ...profile.deny])
    }
  }

  /**
   * List of profiles whose permissions this profile should inherit
   * @type {Array[String]}
   */
  extend

  /**
   * Indicates an internal profile, which is automatically assigned
   * when an account is created
   * @type {Boolean}
   */
  isInternal

  /**
   * Indicates a profile representing a human, as opposed to organizations, companies etc.
   * @type {Boolean}
   */
  isHuman

  /**
   * Overrides serialization to prevent serializing of certain
   * runtime-only properties
   * @returns {Object}
   */
  toJSON () {
    const result = { ...this }
    delete result.created
    delete result.updated
    delete result.deleted
    return result
  }
}
